import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-platform-integrated-solar-financing.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Make Lending Easy with Integrated Solar Financing";

const MainHero = () => (
  <HeroSection title={title} className="flex-col-reverse md:flex-row-reverse">
    <figure className="p-3 w-full xs:w-4/5 sm:w-3/4 md:w-1/2">
      <Image
        src={FigureImage}
        alt="Enerflo integrates with the Top 5 Solar Lenders and has the deepest integrations on the market, making lending easy and enabling reps to get their customers to NTP faster -- all through Lendflo."
        layout="responsive"
        quality={100}
        placeholder="blur"
        loading="eager"
        className="crispImage"
        priority
        sizes="(min-width: 768px) 50vw, 100vw"
      />
    </figure>

    <HeroSection.Content className="md:w-1/2">
      <HeroSection.Header className="md:items-start">
        <Heading tag="h1">{title}</Heading>
      </HeroSection.Header>
      <HeroSection.Description>
        Enerflo integrates with the Top 5 Solar Lenders and has the most lender integrations in the market, making
        lending easy and enabling reps to get their customers to NTP faster -- all through Lendflo.
      </HeroSection.Description>
    </HeroSection.Content>
  </HeroSection>
);

export default MainHero;
